import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const benefits = ['Cómo elegir la habilidad que ya tienes y que alguien en EE.UU. pagaría 10 veces más.', 'Cómo abrir tu cajero digital en dólares en minutos, sin bancos complicados.', 'Cómo conseguir tu primer pago en 14 días o menos, sin saber inglés perfecto.'];
export function SolutionSection() {
  return <section className="py-24 px-4 bg-[#0f0f0f] relative overflow-hidden" data-id="element-172">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#1A7A4A]/50 to-transparent" data-id="element-173" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-[#1A7A4A]/10 blur-[80px] pointer-events-none" data-id="element-174" />

      <div className="max-w-5xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight" data-id="element-177">
            Existe Una Salida: Convertir Tus Habilidades Actuales en{' '}
            <span className="text-[#1A7A4A]" data-id="element-178">Sueldos Globales</span> Sin Dejar
            Tu País
          </h2>
          <p className="text-xl md:text-2xl font-bold text-[#C9A84C]" data-id="element-179">
            La Única Forma de Ganar 4 Veces Más Haciendo Lo Mismo
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-180">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative mx-auto w-full max-w-md" data-id="element-181">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(26,122,74,0.2)]" data-id="element-182">
              <img src="https://cdn.magicpatterns.com/uploads/iqScLxDvnJ96ukbXYc5x7a/heylloyd-image-1773159426247.png" alt="Tu Primer Sueldo en Dólares - Manual de 20 páginas para Latinoamérica" className="w-full h-auto object-cover" data-id="element-183" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/30 to-transparent pointer-events-none" data-id="element-184" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-185">
            <p className="text-2xl font-bold text-white mb-4" data-id="element-186">
              Te presento el manual: <br data-id="element-187" />
              <span className="text-[#C9A84C]" data-id="element-188">
                Tu Primer Sueldo en Dólares
              </span>
            </p>
            <p className="text-lg text-[#D1D5DB] mb-4" data-id="element-189">
              Un ebook de solo 20 páginas que elimina la confusión y te da un
              plan paso a paso:
            </p>
            <p className="text-lg italic text-[#C9A84C]/90 mb-8" data-id="element-190">
              "Este manual es básicamente el atajo que hubiera querido tener
              cuando empecé desde cero."
            </p>

            <div className="space-y-4 mb-8" data-id="element-191">
              {benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-192">
                  <CheckCircle2Icon className="w-6 h-6 text-[#1A7A4A] flex-shrink-0 mt-0.5" data-id="element-193" />
                  <p className="text-[#D1D5DB]" data-id="element-194">{benefit}</p>
                </div>)}
            </div>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-195">
          <CTAButton text="QUIERO SABER CÓMO GANAR EN DÓLARES" data-id="element-196" />
        </div>
      </div>
    </section>;
}